import React, { lazy, ReactNode, Suspense } from 'react';
import { Navigate } from 'react-router';
import { routes } from './routes';
import LoginComponent from '@/pages/login';
import RegisterComponent from '@/pages/registration';
import ForgotPassword from '@/pages/forgotPassword';
import CustomerDashboard from '@/pages/customerDashboard';
import HomePage from '@/pages/home';
import CategoryDetails from '@/pages/categoryDetails';
import ProductDetails from '@/pages/productDescription';
import Cart from '@/pages/cart';
import AllCategory from '@/pages/allCategory';
import Checkout from '@/pages/checkout';
import TrackOrder from '@/pages/trackOrder';
import OrderDetails from '@/pages/orderDetails';
import Pricing from '@/pages/pricing';
import HomeEdit from '@/pages/homeEdit';
import CommonHeaderPage from '@/pages/commonHeaderPage';
import SearchResult from '@/pages/searchResults';
import WareHouseProduct from '@/pages/wareHouseProduct';
import Home3Edit from '@/pages/home-3/edit';
import TableBooking from '@/pages/tableBooking';

export const authRoutes = [
  {
    id: 1,
    path: routes.customerDashboard,
    element: <CustomerDashboard />,
  },
  {
    id: 2,
    path: routes.trackOrder,
    element: <TrackOrder />,
  },
  {
    id: 3,
    path: routes.checkout,
    element: <Checkout />,
  },
    {
    id: 4,
    path: routes.orderDetails,
    element: <OrderDetails />,
  },
];


export const unAuthRoutes = [
  {
    id: 1,
    path: routes.register,
    element: <RegisterComponent />,
  },
  {
    id: 2,
    path: routes.login,
    element: <LoginComponent />,
  },
  {
    id: 3,
    path: routes.forgetPassword,
    element: <ForgotPassword />,
  },
  {
    id: 4,
    path: routes.home,
    element: <HomePage />,
  },
  {
    id: 5,
    path: routes.category,
    element: <CategoryDetails />,
  },
  {
    id: 6,
    path: routes.productDetails,
    element: <ProductDetails />,
  },
  {
    id: 7,
    path: routes.all_category,
    element: <AllCategory />,
  },
  {
    id: 8,
    path: routes.pricing,
    element: <Pricing />,
  },
  {
    id: 9,
    path: routes.homeEdit,
    element: <HomeEdit />,
  },
  {
    id: 10,
    path: routes.commonHeader,
    element: <CommonHeaderPage />,
  },
  {
    id: 11,
    path: routes.cart,
    element: <Cart />,
  },
  {
    id: 12,
    path: routes.searchResult,
    element: <SearchResult />,
  },
  {
    id: 13,
    path: routes.wareHouseProduct,
    element: <WareHouseProduct />,
  },
  {
    id: 14,
    path: routes.tableBooking,
    element: <TableBooking />,
  },
];

export const LazyWrapper: React.FC<{ children: ReactNode }> = ({
  children,
}) => <Suspense>{children}</Suspense>;
